export default [
    {
        path: '/admin/report/candidate-profile-lists',
        name: 'report-candidate-profile-list',
        meta: { requiresAuth: true },
        component: () => import('@/pages/report/candidate-profile-list.vue')
    },
    {
        path: '/admin/report/exam-registration-lists',
        name: 'report-exam-registration-list',
        meta: { requiresAuth: true },
        component: () => import('@/pages/report/exam-registration-list.vue')
    },
    {
        path: '/admin/report/exam-evaluation-lists',
        name: 'report-exam-evaluation-list',
        meta: { requiresAuth: true },
        component: () => import('@/pages/report/exam-evaluation-list.vue')
    },
    {
        path: '/admin/report/exam-evaluation-details',
        name: 'report-exam-evaluation-detail',
        meta: { requiresAuth: true },
        component: () => import('@/pages/report/exam-evaluation-detail.vue')
    },
    {
        path: '/admin/report/print-operation-lists',
        name: 'report-print-operation-list',
        meta: { requiresAuth: true },
        component: () => import('@/pages/report/print-operation-list.vue')
    },
]
